import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  private _currentLanguage?: string;


  constructor(
    private translate: TranslateService,
    private router: Router
  ) {
    this.initializeLanguage();
  }

  private initializeLanguage() {
    const savedLang = localStorage.getItem("currentLang") || 'ar';
    this._currentLanguage = savedLang;
    this.translate.setDefaultLang(savedLang);
    this.translate.use(savedLang);
    this.setHtmlLanguageAttribute();
  }


  get currentLanguage(): string {
    return this._currentLanguage || localStorage.getItem("currentLang") || 'ar';
  }
  set currentLanguage(value: string) {
    this._currentLanguage = value;
    localStorage.setItem("currentLang", this._currentLanguage);
    this.setHtmlLanguageAttribute();

  }
  private setHtmlLanguageAttribute() {
    if (this._currentLanguage === "ar") {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
      document.body.classList.remove('en');
      document.body.classList.add('ar');
    }
    else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = 'en';
      document.body.classList.remove('ar');
      document.body.classList.add('en');
    }
  }
  setLanguage(lang: string) {
    this.currentLanguage = lang;
    this.translate.use(lang);
    this.setHtmlLanguageAttribute();
  }
  async switchLang(lang: string): Promise<void> {
    this.setLanguage(lang);
    // Navigate to current route to refresh the language
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }


}

